<template>
    <span>
        <button
            class="btn btn-primary"
            data-test-id="upload-diagnostic-log-button"
            @click.prevent="openModal"
        >
            Upload
        </button>

        <prime-dialog
            :visible="modalVisible"
            header="Upload Diagnostic Log"
            class="upload-diagnostic-log-dialog"
            data-test-id="upload-diagnostic-log-dialog"
            :draggable="false"
            :dismissableMask="false"
            :pt="{
                pcCloseButton: {
                    root: { 'data-test-id': 'close-diagnostic-log-upload-button' },
                },
            }"
            modal
            @update:visible="handleVisibleChange"
        >
            <upload-diagnostic-log-form
                v-if="modalVisible"
                ref="form"
                @cancel="closeModal"
                @uploaded="uploadComplete"
            />
        </prime-dialog>
    </span>
</template>

<script>
import Dialog from 'primevue/dialog'
import UploadDiagnosticLogForm from '@/components/DiagnosticLogs/UploadDiagnosticLogForm.vue'
import canToast from '@/mixins/canToast'

export default {
    name: 'UploadDiagnosticLogButton',

    components: {
        PrimeDialog: Dialog,
        UploadDiagnosticLogForm,
    },

    mixins: [canToast],

    emits: ['uploaded'],

    data() {
        return {
            modalVisible: false,
        }
    },

    methods: {
        openModal() {
            this.modalVisible = true
        },

        // The dialog's close button and the escape key both ask to hide the
        // modal; hand that off to the form so it can prompt, abort an upload,
        // or refuse while a submit is in flight
        handleVisibleChange(visible) {
            if (visible) {
                this.modalVisible = true
                return
            }

            this.$refs.form.requestClose()
        },

        // closing the modal unmounts the form, which aborts any in-flight upload
        closeModal() {
            this.modalVisible = false
        },

        uploadComplete() {
            this.closeModal()
            this.toast('Diagnostic log successfully uploaded!')
            this.$emit('uploaded')
        },
    },
}
</script>

<style lang="scss">
.upload-diagnostic-log-dialog.p-dialog {
    width: 500px;
    max-width: 90vw;
    background-color: #434a4d;
    color: #999;
    border: 1px solid #43474a;

    .p-dialog-title {
        color: #fff;
    }

    // forms are globally capped at 420px, which leaves the form narrower than
    // the dialog and flush left against it; let it fill the content box instead
    .p-dialog-content form {
        max-width: none;
    }
}
</style>
